import { DOCUMENT } from '@angular/common';
import {
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { StorageKeyEnum } from '@app/core/enums/storage-key.enum';
import { ToolsHelper } from '@app/core/helpers/tools.helper';
import {
  AnalyticsEvents,
  AnalyticsService,
  APP_CONFIG,
  EventsService,
  IAppConfig,
  StorageService,
} from '@app/core/services';

@Component({
  selector: 'app-core-header',
  templateUrl: './core-header.component.html',
  styleUrls: ['../wl-header/header-btns.scss', './core-header.component.scss'],
})
export class CoreHeaderComponent implements OnInit, OnDestroy {
  @ViewChild('header', { static: true }) header: ElementRef;

  public readonly ToolsHelper = ToolsHelper;
  public readonly nowDate = new Date().toISOString();

  showError = false;
  errorText = '';
  mobileMenuIsShow = false;
  toggleSMobileMenu: UntypedFormControl;

  private destroy$: Subject<void> = new Subject();

  constructor(
    @Inject(APP_CONFIG) public readonly appConfig: IAppConfig,
    @Inject(DOCUMENT) private document: Document,
    private router: Router,
    private storageService: StorageService,
    public eventsService: EventsService,
    private analyticsService: AnalyticsService,
  ) {}

  ngOnInit(): void {
    this.storageService.setStorageItem(StorageKeyEnum.IS_ERROR_SHOW, false);
    this.eventsService.errorHappens$
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => {
        if (value !== null) {
          this.showError = true;
          this.storageService.setStorageItem(
            StorageKeyEnum.IS_ERROR_SHOW,
            true,
          );
          this.errorText = value;
        }
      });
    this.router.events.pipe(takeUntil(this.destroy$)).subscribe(val => {
      if (val instanceof NavigationEnd) {
        if (val.url === '/') {
          this.header.nativeElement.classList.add('fixed');
        } else {
          this.header.nativeElement.classList.remove('fixed');
        }
        this.showError = false;
        this.storageService.setStorageItem(StorageKeyEnum.IS_ERROR_SHOW, false);
      }
    });
    this.toggleSMobileMenu = new UntypedFormControl();
    this.toggleSMobileMenu.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => {
        this.mobileMenuIsShow = value;
        const root: any = this.document.querySelectorAll('html')[0];
        if (value) {
          this.document.body.classList.add('modal-open');
          root.classList.add('modal-open');
        } else {
          this.document.body.classList.remove('modal-open');
          root.classList.remove('modal-open');
        }
      });
    this.eventsService.closeMobileMenuValue$
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => {
        if (this.toggleSMobileMenu && value) {
          this.toggleSMobileMenu.patchValue(false);
        } else if (this.toggleSMobileMenu && !value) {
          this.toggleSMobileMenu.patchValue(true);
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

  hideError(): void {
    this.showError = false;
    this.storageService.setStorageItem(StorageKeyEnum.IS_ERROR_SHOW, false);
  }

  sendLogoAnalytics(): void {
    this.analyticsService.emitEvent(AnalyticsEvents.navigationLogo, {});
  }
}
